/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Group_ActionsInputs */

const tr_landing_shortcuts_mock_group_actions = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İŞLEMLER`)
};

const en_landing_shortcuts_mock_group_actions = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIONS`)
};

const de_landing_shortcuts_mock_group_actions = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTIONEN`)
};

const ru_landing_shortcuts_mock_group_actions = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЕЙСТВИЯ`)
};

/**
* | output |
* | --- |
* | "ACTIONS" |
*
* @param {Landing_Shortcuts_Mock_Group_ActionsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_group_actions = /** @type {((inputs?: Landing_Shortcuts_Mock_Group_ActionsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Group_ActionsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_group_actions(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_group_actions(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_group_actions(inputs)
	return tr_landing_shortcuts_mock_group_actions(inputs)
});